import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SaveIcon from '@mui/icons-material/Save';
import { useSearchParams } from "react-router-dom";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import axios from "axios";
import { sha256 } from 'crypto-hash';
import { MuiFileInput } from 'mui-file-input';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';

interface props {
  setDocumentChange: React.Dispatch<React.SetStateAction<boolean>>
  userAuthenticated: string
}

export const UpdateDocsVersion: React.FC<props> = ({ setDocumentChange, userAuthenticated }) => {

  const navigate = useNavigate();

  const [saved, setSaved] = useState<boolean>(false);
  const [created, setCreated] = useState<boolean>(false);
  const [description, setDescription] = useState<string>("");
  const [version, setVersion] = useState<string>("");
  const [document, setDocument] = useState<File | null>(null);
  const [hash, setHash] = useState<string>("");
  // get from URI
  const [searchParams, setSearchParams] = useSearchParams();
  const docId:string|null = searchParams.get("document")
  const docName:string|null = searchParams.get("documentName")

  const handleChange = async (newDocument: File | null) => {
    setDocument(newDocument);
    // getChecksum(document);
    if (!newDocument) return;
    let documentContent = await newDocument.arrayBuffer();
    let result = await sha256(documentContent);
    console.log(result);
    setHash(result);
  }

  const handleCancel = () => {
    setCreated(false);
    setSaved(false);
    setVersion("");
    setHash("");
    setDocument(null);
  }


  const handleSubmit = () => {
    setSaved(true);
    if (document == null || version === "")
      return;

    let formData = new FormData();
    formData.set('uploaded_file', document);
    formData.set('file_desc', description);
    formData.set('version', version);
    formData.set('owner', userAuthenticated);
    axios.post(`http://52.210.115.63:15060/update/${docId}`, formData).then(async res => {
      setCreated(true);
      setDocumentChange(true)
      navigate("/documents")
    }).catch(e => { console.log(e); (alert(e)); });
  }

  return (<>
    {/* Titolo */}
    <div className='panel-title'>
      <h1>UPDATE DOCUMENT VERSION</h1>
      <Button variant="outlined" disableElevation
        size="large" startIcon={<ArrowBackIosNewIcon />}
        onClick={e => navigate("/documents")}
      >Back</Button>
    </div>
    
    <Box className='panel-content' component="form" autoComplete="off">
      <div>
      <h2>Use this form to update the document with a new version</h2>
        <TextField  value={description} onChange={e => {setDescription(e.target.value)}} fullWidth variant="outlined" margin="normal" name="name" label="Document Name" />
        {/* <TextField fullWidth variant="outlined" margin="normal" error={saved && name == ''} required={true} value={version} onChange={e => { setVersion(e.target.value) }} name="version" label="Document Version" /> */}
        <TextField fullWidth variant="outlined" margin="normal"  required={true} value={version} onChange={e => {setVersion(e.target.value)}} name="version" label="Document Version" />
        <MuiFileInput className="file-input-mui" variant="outlined" margin="normal" error={saved && document == null} placeholder='Click to upload a document' value={document} onChange={handleChange} />
        <div style={{ display: 'inline-flex', margin: '8px 24px 16px', lineHeight: "60px" }}>{hash}</div>
      </div>
      <div className='bottom-btns'>
        <Button disableElevation size="large" variant="contained" endIcon={<SaveIcon />} onClick={e => handleSubmit()}>SAVE</Button>
        <Button disableElevation size="large" variant="outlined" endIcon={<RestartAltIcon />} onClick={e => handleCancel()}>RESET</Button>
      </div>
    </Box>

    <Dialog
      open={created}
      onClose={handleCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>Upload Document <CheckCircleOutlineIcon />
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          The document has been uploaded successfully
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  </>);
}